import React from "react";
import { Button, CircularProgress, SxProps, Theme } from "@mui/material";

interface FloatingActionButtonProps {
  label: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  visible?: boolean;
  loading?: boolean;
  primaryColor?: string;
  sx?: SxProps<Theme>;
}

const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({
  label,
  onClick,
  disabled = false,
  visible = true,
  loading = false,
  primaryColor = "#0047C0",
  sx,
}) => {
  if (!visible) return null;

  return (
    <Button
      variant="contained"
      onClick={!disabled && !loading ? onClick : undefined}
      sx={[
        styles.Button,
        {
          backgroundColor: primaryColor,
          cursor: disabled || loading ? "not-allowed" : "pointer",
          "&:hover": {
            backgroundColor: primaryColor,
            opacity: 0.9,
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      disabled={disabled}
    >
      {loading ? (
        <CircularProgress size={24} sx={{ color: "white" }} />
      ) : (
        label
      )}
    </Button>
  );
};

const styles = {
  Button: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    color: "white",
    padding: "8px 24px",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: 600,
    textTransform: "none",
    minHeight: "44px",
    zIndex: 50,
    "&:hover": {
      opacity: 0.9,
    },
  },
};

export default FloatingActionButton;
